module.exports = __webpack_public_path__ + "static/media/equity_derivatives_transparent.b034dd4f.svg";